import { uniqBy } from 'lodash';

import { type GenerationTool, getToolResultLabel } from 'src/data/generationTool';

export interface ToolResult {
  /** The first of the result's tools — the one whose icon stands for it. */
  tool: GenerationTool;
  /** What the result is called; absent for a tool that names nothing. */
  label?: string;
}

/**
 * One entry per result: the tools that make up one result (a Meta Image Ad's headline, primary text
 * and image) collapse into one, while two results that share an icon (Google Search Ad and Google
 * Display Ad) stay two. A tool with no label is a result of its own, told apart by the tool.
 */
export const groupToolsByResult = (tools: GenerationTool[]): ToolResult[] =>
  uniqBy(
    tools.map((tool) => ({ tool, label: getToolResultLabel(tool) })),
    ({ tool, label }) => label ?? tool
  );
